import { TFunction } from 'i18next'

// All status types including UNCLASSIFIED (for create form)
export const ContactStatusTypes = (t: TFunction<'translation', undefined>) => [
    {
        value: 'UNCLASSIFIED',
        label: t('contact-un-classified'),
    },
    {
        value: 'warm-lead',
        label: t('lead_flow.warm_lead'),
    },
    {
        value: 'sale-qualified-lead',
        label: t('lead_flow.sql'),
    },
    {
        value: 'cool-lead',
        label: t('lead_flow.cool_lead'),
    },
    {
        value: 'un-qualified-lead',
        label: t('lead_flow.unqualified'),
    },
]

// Assignment status filter options
export const AssignmentStatusTypes = (
    t: TFunction<'translation', undefined>
) => [
    {
        value: '',
        label: t('all'),
    },
    {
        value: 'unassigned_stale',
        label: t('unassigned-stale'),
    },
    {
        value: 'assigned',
        label: t('assigned'),
    },
]

// Filter options
export const ContactStatusFilterTypes = (
    t: TFunction<'translation', undefined>
) => [
    {
        value: 'UNCLASSIFIED',
        label: t('contact-un-classified'),
    },
    {
        value: 'warm-lead',
        label: t('lead_flow.warm_lead'),
    },
    {
        value: 'sale-qualified-lead',
        label: t('lead_flow.sql'),
    },
    {
        value: 'cool-lead',
        label: t('lead_flow.cool_lead'),
    },
    {
        value: 'un-qualified-lead',
        label: t('lead_flow.unqualified'),
    },
]

export const getContactStatusTypesColor = (status: string) => {
    switch (status) {
        case 'warm-lead':
            return 'warning'
        case 'sale-qualified-lead':
            return 'success'
        case 'cool-lead':
            return 'info'
        case 'un-qualified-lead':
            return 'error'
        case 'UNCLASSIFIED':
            return 'default'
        default:
            return 'default'
    }
}

// Customer lead type options (for optional classification)
export const CustomerLeadTypes = (t: TFunction<'translation', undefined>) => [
    {
        value: 'warm-lead',
        label: t('lead_flow.warm_lead'),
    },
    {
        value: 'sale-qualified-lead',
        label: t('lead_flow.sql'),
    },
    {
        value: 'cool-lead',
        label: t('lead_flow.cool_lead'),
    },
    {
        value: 'un-qualified-lead',
        label: t('lead_flow.unqualified'),
    },
]

export const ContactChanel = (t: TFunction<'translation', undefined>) => [
    {
        value: 'form',
        label: t('contact-form'),
    },
    {
        value: 'gg_ads',
        label: t('gg-ads'),
    },
    {
        value: 'fb_ads',
        label: t('fb-ads'),
    },
    {
        value: 'livechat',
        label: t('live-chat'),
    },
    {
        value: 'fb_messenger',
        label: t('fanpage-chat'),
    },
    {
        value: 'hotline',
        label: t('hotline'),
    },
    {
        value: 'event',
        label: t('event'),
    },
    {
        value: 'email',
        label: t('email'),
    },
    {
        value: 'research',
        label: t('marketing:research'),
    },
]

// Re-export from single source of truth
export { INDUSTRIES as Industries } from '@/modules/Customer/constants'
export { INDUSTRY_OPTIONS as IndustryOptions } from '@/modules/Customer/constants'
export const Services = [
    {
        value: 'CDN',
        label: 'CDN',
    },
    {
        value: 'CONTENT DELIVERY NETWORK',
        label: 'CONTENT DELIVERY NETWORK',
    },
    {
        value: 'CLOUD SERVER',
        label: 'CLOUD SERVER',
    },
    {
        value: 'VPS',
        label: 'VPS',
    },
    {
        value: 'HOSTING',
        label: 'HOSTING',
    },
    {
        value: 'TRANSCODING',
        label: 'TRANSCODING',
    },
    {
        value: 'SECUMAIL',
        label: 'SECUMAIL',
    },
    {
        value: 'DOMAIN',
        label: 'DOMAIN',
    },
    {
        value: 'EMAIL',
        label: 'EMAIL',
    },
    {
        value: 'EMAIL-VPRO',
        label: 'EMAIL VPRO',
    },
    {
        value: 'COLOCATION',
        label: 'COLOCATION',
    },
    {
        value: 'WEBSITE',
        label: 'WEBSITE',
    },
    {
        value: 'STORAGE',
        label: 'STORAGE',
    },
    {
        value: 'SSL',
        label: 'SSL',
    },
    {
        value: 'SERVER',
        label: 'SERVER',
    },
    {
        value: 'Receive Guard',
        label: 'Receive Guard',
    },
    {
        value: 'LIVESTREAM',
        label: 'LIVESTREAM',
    },
    {
        value: 'VNIS',
        label: 'VNIS',
    },
    {
        value: 'LSDN',
        label: 'LSDN',
    },
    {
        value: 'OTHERS',
        label: 'OTHERS',
    },
    {
        value: 'BMS',
        label: 'BMS',
    },
]
